import Navbar from "../components/Navbar";
import ImageCard from "../components/ImageCard";
import ImageCardDetails from "../components/ImageCardDetails";
import ContactSection from "../components/ContactSection";
import FaqSection from "../components/FaqSection";
import Sidebar from "../components/Sidebar";
import integrationHeroImage from "./../assets/integration-hero-image.png";
import apiIntegrationImage from "./../assets/api-integration-image.png";
import crossPlatformImage from "./../assets/cross-platform-image.png";
import realTimeResponseImage from "./../assets/real-time-response-image.png";
import modularMLImage from "./../assets/modular-ml-image.png";
import tokenGenerationImage from "./../assets/token-generation-image.png";
import adminPanelImage from "./../assets/admin-panel-image.png";
import Userflow from "../components/Userflow";
import { homeDesktopItems, homeMobileItems } from "../data/mockData.js";
import Footer from "../components/Footer.js";
import { Link } from "react-router-dom";
import { integrationsFaqs } from "../data/faqs.js";

const Integration = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar desktopItems={homeDesktopItems} mobileItems={homeMobileItems} />      
      <main className="pl-0 md:pl-6">
        {/* Page layout: sidebar + content */}
        <div className="flex gap-1">
          {/* Sidebar */}
          <Sidebar />

          {/* Content */}
          <div className="flex-1">
            {/* HERO SECTION */}
            <section className="rounded-[10px] bg-white p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="order-1 lg:order-2 lg:justify-self-end w-full">
                  <div className="w-full h-[396px] rounded-[10px] overflow-hidden relative bg-[linear-gradient(to_bottom,_#E9D6D2_0%,_#DFA8A1_45%,_#C97F7C_75%,_#B75E5C_100%)]">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="h-[45%] md:h-[65%] rounded-[8px] overflow-hidden">
                        <img
                          src={integrationHeroImage}
                          alt="Eveness solutions hero"
                          className="w-full h-full object-contain"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="order-2 lg:order-1 max-w-[520px]">
                  <div className="text-[32px] md:text-[38px] leading-[100%] font-normal tracking-[-1.6px] text-black font-inter">
                    Integration
                  </div>

                  <p className="mt-4 text-[14.5px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A] max-w-[440px] font-normal">
                    The Eveness API 'free tier' offers immediate access with no
                    sign-up call required. To unlock your own branded GPT,
                    advanced data systems, and an algorithm that works on
                    collection pages please schedule a call. Our aim is to
                    empower the fashion industry and assist in creating happier
                    customers that shop more and return less.
                  </p>

                  <Link to="/get-started">
                    <button
                      type="button"
                      className="mt-6 inline-flex items-center justify-center w-[124px] h-[40px] rounded-[8px] px-[20px] py-[12.6px] border border-black bg-white text-black opacity-100 whitespace-nowrap transition-colors duration-200 hover:bg-black hover:text-white"
                    >
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>{" "}
            </section>
            {/* SECOND SECTION */}
            <section className="mt-[40px] md:mt-[100px] rounded-[10px] bg-white p-6 mb-[50px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch bg-white">
                <ImageCard imageSrc={apiIntegrationImage} bgColor={"#E9F3FF"} source="api-integration" />
                <ImageCardDetails
                  title="API integration"
                  description="From auth to inference, we streamline every step of your integration"
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Admin Panel"
                    description="Manage Clients, Assign Clients."
                    source="integration"
                    linkTextOne="Product description page with fit and size check agent"
                    linkTextTwo="Product description page with fit and size check agent"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard imageSrc={adminPanelImage} bgColor={"#DAF3DA4D"} source="integration" />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard
                  imageSrc={tokenGenerationImage}
                  bgColor={"#FBEBF9"}
                  source="integration"
                />
                <ImageCardDetails
                  title="Token Generation"
                  description="Secure OAuth-based token system for API key issuance."
                  source="integration"
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Modular ML Endpoints"
                    description="Plug in style, fit, and color modules as needed."
                    linkTextOne="Product description page with fit and size check agent"
                    linkTextTwo="Product description page with fit and size check agent"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard imageSrc={modularMLImage} bgColor={"#EBF1FB"} />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard
                  imageSrc={realTimeResponseImage}
                  bgColor={"#ECEBFB"}
                  source="integration"
                />
                <ImageCardDetails
                  title="Real-Time Response"
                  description="Sub-300ms latency for style logic and recommendations"
                  source="integration"
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Cross Platform Support"
                    description="Use with React, Vue, Shopify, Python, REST, etc."
                    source="integration"
                    linkTextOne="Product description page with fit and size check agent"
                    linkTextTwo="Product description page with fit and size check agent"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard
                    imageSrc={crossPlatformImage}
                    bgColor={"#FADEDE"}
                    source="integration"
                  />
                </div>
              </div>
            </section>
            <Userflow />
            <section className="mt-10 rounded-[10px] px-3 md:px-6">
              <ContactSection />
              <div className="mt-[52px]">
                <FaqSection faqs={integrationsFaqs} />
              </div>
            </section>
            <Footer />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Integration;
